/**
 * A form in the classic two-column layout:
 * - labels in the left column, right-aligned.
 * - fields in the right column.
 * TODO Implement.
 *
 * @type {import("../useFormTheme").FormTheme}
 */
const wizard = {
    form: {},
    fieldLayout: { display: 'flex', gap: 2, paddingBottom: 2 },
    label: {
        width: '50%',
        textAlign: 'right',
        alignItems: 'baseline',
        paddingY: 2,
    },
    field: { width: '50%', alignItems: 'baseline' },
    textArea: {},
    input: {},
    checkbox: {},
    radio: {},
    description: {},
    warning: {},
    error: {},
};
export default wizard;
//# sourceMappingURL=wizard.js.map